// implements src\views\mixins\session-action.js
import { useTypedStore } from '@/store';
import { computed, ref, watch } from 'vue';

export function useSessionAction() {
  const store = useTypedStore();

  const onSessionUnlock = ref(() => {});
  const isFirstLoad = ref(true);
  const significantActionsSeconds = computed(() => store.getters['session/significantActionsSeconds']);

  const significantActionsSecondsWatchHandle = watch(significantActionsSeconds, (newVal, oldVal) => {
    if (isFirstLoad.value) {
      isFirstLoad.value = false;
      return;
    }

    if (oldVal === 0 && newVal) {
      onSessionUnlock.value();
    }
  });

  return {
    onSessionUnlock,
    significantActionsSeconds,
    significantActionsSecondsWatchHandle,
  }
}
